import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useNotification } from '../../context/NotificationContext';
import { usePrompt } from '../../context/PromptContext';
import CartBox from '../CartBox/CartBoxSection';

const CartSide = () => {
 const navigate = useNavigate();
 const { clearCart, cartData } = useCart();
 const { notify } = useNotification();
 const { initPrompt } = usePrompt();

 const handleClear = async () => {
  const callbackFunc = async () => {
   let resp = await clearCart();
   if (resp) {
    notify.success('Cart cleared!');
   }
  };

  initPrompt(
   'Clear your cart?',
   'All products will be cleared from your cart',
   callbackFunc,
  );
 };
 return (
  <div>
   <div className="pagetitle">
    <div
     className="icon goback"
     onClick={() => navigate(-1)}
    ></div>
    <div>Shopping cart</div>
   </div>

   <CartBox></CartBox>

   {cartData.length >= 1 && (
    <div className="btn-pack">
     <button
      className="clear-btn"
      onClick={handleClear}
     >
      Clear cart
     </button>
    </div>
   )}
  </div>
 );
};

export default CartSide;
